export function applyDir(lang: string) {
  const rtl = lang.startsWith('ar');
  document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lang);
  
  // Add/remove RTL class for styling
  if (rtl) {
    document.body.classList.add('rtl');
    document.body.classList.remove('ltr');
  } else {
    document.body.classList.add('ltr');
    document.body.classList.remove('rtl');
  }
}

export function isRTL(lang: string): boolean {
  return lang.startsWith('ar');
}

export function getTextDirection(lang: string): 'ltr' | 'rtl' {
  return isRTL(lang) ? 'rtl' : 'ltr';
}